import type { MetaDescriptor } from 'react-router';

export const APP_NAME = 'Granular Energy';

// Page name first so it survives tab truncation when several pages are open.
export const pageMeta = (title: string): MetaDescriptor[] => [{ title: `${title} | ${APP_NAME}` }];
